(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hamamat-product-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hamamat-product-accordion')) {
    customElements.define(
      'hamamat-product-accordion',
      class extends HTMLElement {
        #observer = new MutationObserver(() => this.#syncRows());

        connectedCallback() {
          // Native details toggle events do not bubble, so use capture.
          this.addEventListener('toggle', this.#handleToggle, true);
          this.#syncRows();
          this.#observer.observe(this, { childList: true, subtree: true });
        }

        disconnectedCallback() {
          this.removeEventListener('toggle', this.#handleToggle, true);
          this.#observer.disconnect();
        }

        #rows() {
          return Array.from(this.querySelectorAll('details.hamamat-product-accordion__row')).filter(
            (row) => row.closest('hamamat-product-accordion') === this
          );
        }

        #syncRows() {
          const rows = this.#rows();
          this.toggleAttribute('hidden', rows.length === 0);
          let foundOpenRow = false;

          // If several rows are set to open by default, retain the first.
          for (const row of rows) {
            if (row.hasAttribute('open')) {
              if (foundOpenRow) row.removeAttribute('open');
              else foundOpenRow = true;
            }
          }

          // A unique native group prevents competing queued toggle events.
          // Reapply when rows are inserted or replaced in the theme editor.
          for (const row of rows) {
            if (row.getAttribute('name') !== this.id) row.setAttribute('name', this.id);
          }
        }

        #handleToggle = (event) => {
          const openedRow = event.target;
          if (
            !(openedRow instanceof Element) ||
            !openedRow.matches('details.hamamat-product-accordion__row[open]') ||
            openedRow.closest('hamamat-product-accordion') !== this
          ) return;

          // Also enforces exclusivity in browsers without native details groups.
          for (const row of this.#rows()) {
            if (row !== openedRow) row.removeAttribute('open');
          }
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
